import { Component, OnInit, Input, OnChanges, SimpleChanges } from '@angular/core';
import { ITotaltable } from '../../../interfaces/ITotaltable';

@Component({
    selector: 'app-tool-bar-footer',
    templateUrl: './tool-bar-footer.component.html',
    styleUrls: ['./tool-bar-footer.component.scss']
  })

export class ToolBarFooterComponent implements OnInit, OnChanges {
    @Input() totalTable: ITotaltable;

    public totalPENFormat = '';
    public totalCOFormat = '';
    public totalUSDFormat = '';

    public currencyPEN = false;
    public currencyCOP = false;
    public currencyUSD = false;

    ngOnInit(): void {
      this.updateData();
    }

    ngOnChanges(changes: SimpleChanges): void {
      this.updateData();
    }

    private updateData(): void {
      this.currencyPEN = false;
      this.currencyCOP = false;
      this.currencyUSD = false;
      setInterval(() => {
        if (this.totalTable.currency === 'COP') {
          this.currencyCOP = true;
        }
        if (this.totalTable.currency === 'PEN') {
          this.currencyPEN = true;
        }
        if (this.totalTable.currency === 'USD') {
          this.currencyUSD = true;
        }
      }, 1000);
      let formatter = new Intl.NumberFormat('es-CO', {
        style: 'currency',
        currency: 'COP',
        minimumFractionDigits: 2,
      });
      this.totalCOFormat = formatter.format(this.totalTable.totalCOP);
      formatter = new Intl.NumberFormat('es-PE', {
        style: 'currency',
        currency: 'PEN',
        minimumFractionDigits: 2,
      });
      this.totalPENFormat = formatter.format(this.totalTable.totalPEN);
      formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 2,
      });
      this.totalUSDFormat = formatter.format(this.totalTable.TotalUSD);

      this.totalCOFormat = '(COP)' + this.totalCOFormat;
      this.totalUSDFormat = '(USD)' + this.totalUSDFormat;
    }

}
